import { createFileRoute } from '@tanstack/react-router';

import { useFunnelBoot } from '../booking/lib/boot';
import { PaperworkPage } from '../booking/paperwork-page';

/** Step 4 of the funnel (MASTER_PLAN M5.6, M5.7). */
export const Route = createFileRoute('/paperwork')({
  component: PaperworkRoute,
});

function PaperworkRoute() {
  useFunnelBoot('intake');
  return <PaperworkPage />;
}
